import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-accordian',
  templateUrl: './accordian.component.html',
  styleUrls: ['./accordian.component.scss']
})
export class AccordianComponent {
  hasContentBelow = true;
  hasIconLeftSide = false;
  hasActions = true;
  hasDefaultExpanded = false;
  collapseLabel = 'Collapse';
  expandLabel = 'Expand';

  isBrowser = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
}